import {color} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export const materialUiSchema = z.optional(
    z.strictObject({
        disabled: z.optional(z.boolean()),
        internalColor: z.optional(color),
        internalLabel: z.optional(z.string()),
        position: z.optional(
            z.strictObject({
                x: z.number(),
                y: z.number(),
            }),
        ),
    }),
)
